<template>
  <li
    class="
      p-4
      mb-3
      flex
      justify-between
      items-center
      border border-light-grey
      rounded-lg
      cursor-move
    "
    style="background-color: #f8fafb"
  >
    <div class="flex items-center">
      <feather-icon
        icon="MenuIcon"
        svgClasses="h-3 w-3"
        class="mr-5 p-1"
      ></feather-icon>
      <feather-icon
        :icon="iconMap[question.type]"
        svgClasses="h-4 w-4"
        class="
          p-2
          inline-flex
          rounded-md
          bg-white
          border border-light-grey
          shadow
        "
      ></feather-icon>
      <p class="ml-4 text-gray-700 font-semibold font-sans tracking-wide">
        {{ question.title }}
      </p>
    </div>
    <div class="flex">
      <button
        aria-label="Edit question"
        class="
          action-button
          p-1
          focus:outline-none focus:shadow-outline
          text-gray-600
          hover:text-teal-600
        "
        @click="$emit('on-edit', question)"
      >
        <feather-icon
          icon="EditIcon"
          svgClasses="h-5 w-5"
          class="p-1 inline-flex"
        ></feather-icon>
      </button>
    </div>
  </li>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      iconMap: {
        yesNo: "CheckSquareIcon",
        yesNoCritical: "AlertOctagonIcon",
        text: "TypeIcon",
        number: "DollarSignIcon",
        rating: "StarIcon",
        photoMultipleUpload: "CameraIcon",
      /*   photoUpload: "CameraIcon",
        videoUpload: "VideoIcon", */
        videoMultipleUpload: "VideoIcon",
      },
    };
  },
  props: {
    question: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>


<style scoped lang="css" src="@/assets/css/tailwind.min.css"></style>